import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        pageTabs: [{
            title: "主页",
            url: '/console',
            checked: true
        }]
    },
    mutations: {},
    actions: {},
    modules: {}
})